import { getParsedLocalStorageItem } from "../../../../../../presentation/helpers";

type UserRegisterInfo = {
  userEmail: string | null;
  registerData: any;
};

const getUserRegisterInfo = (): UserRegisterInfo => {
  const userRegister = getParsedLocalStorageItem<{ email: string }>(
    "@lucralizeTech:userRegister",
  );
  const registerData = getParsedLocalStorageItem("registerData");

  return {
    userEmail: userRegister?.email || null,
    registerData,
  };
};

export default getUserRegisterInfo;
